/**
 * POWRÓT DO „CZEGO SZUKAM” po edycji Moich filtrów z profilu (Maciek 20.10). Wyszukiwarka wraca
 * krokiem wstecz w historii (bez drugiego wpisu profilu), więc sekcji do otwarcia nie da się
 * przekazać w stanie wpisu — jedzie w sessionStorage i jest zużywana raz, przy montowaniu profilu.
 * Pamięć przeglądarki bywa zablokowana (tryb prywatny): wtedy profil otwiera się zwyczajnie.
 */
const KLUCZ = 'flathero.powrot_do_profilu';

/**
 * `public_profile` / `identity`: pozycja okna „czego brakuje” do publikacji, dotknięta poza
 * profilem (Ustawienia, krok go-live) — profil otwiera się z Wizytówką albo Tożsamością.
 */
const SEKCJE = ['what_i_seek', 'public_profile', 'identity'] as const;
export type SekcjaPowrotu = (typeof SEKCJE)[number];

export function oznaczPowrotDoSekcji(sekcja: SekcjaPowrotu): void {
  try {
    sessionStorage.setItem(KLUCZ, sekcja);
  } catch {
    // brak pamięci sesji — profil otworzy się bez rozwiniętej sekcji
  }
}

export function oznaczPowrotDoCzegoSzukam(): void {
  oznaczPowrotDoSekcji('what_i_seek');
}

export function odbierzSekcjePowrotu(): SekcjaPowrotu | null {
  try {
    const v = sessionStorage.getItem(KLUCZ);
    sessionStorage.removeItem(KLUCZ);
    return (SEKCJE as readonly (string | null)[]).includes(v) ? (v as SekcjaPowrotu) : null;
  } catch {
    return null;
  }
}

/**
 * Co robi wyszukiwarka po „Zapisz” w trybie edycji z profilu, krok po kroku:
 * - `czekaj` — zapis jeszcze trwa albo pytanie o e-maile jest otwarte;
 * - `czekaj_na_pytanie` — pierwszy zapis: pytanie wjeżdża za chwilę (z bezpiecznikiem czasu);
 * - `zostan` — zapis odrzucony: komunikat o błędzie jest, człowiek zostaje przy wyszukiwarce;
 * - `wroc` — zapisane (i pytanie, jeśli było, zamknięte): wracamy do profilu.
 */
export type KrokPowrotu = 'czekaj' | 'czekaj_na_pytanie' | 'zostan' | 'wroc';

export function krokPowrotu(s: {
  czekaNaPytanie: boolean;
  sprawdza: boolean;
  blad: boolean;
  pytanie: boolean;
  pytanieWidziane: boolean;
}): KrokPowrotu {
  if (s.sprawdza) return 'czekaj';
  if (s.blad) return 'zostan';
  if (s.czekaNaPytanie) {
    if (s.pytanie) return 'czekaj';
    if (!s.pytanieWidziane) return 'czekaj_na_pytanie';
  }
  return 'wroc';
}
